function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { isType, NationalCloudSettingAction, EmbeddedAppSettingAction, EmbeddedHostAction, LocStringsReceivedAction, ChangeLocaleLanguage, FlightCodesReceivedAction, CorrelationIdReceivedAction, BreadcrumbAction, TelemetryLoggedAction, SetCurrentViewAction, SetLandingViewAction, UpdateCurrentGalleryViewIsCuratedAction, AppsPricingDataReceivedAction, FeatureFlagsReceivedAction, BillingRegionAction, ABTestingEnableAction, GlobalSettingsReceivedAction, IsMobileReceivedAction, CheckoutConfigAction, IsManageModalOpenAction, SetWCPConsentAction, SetIsConsentRequired, SetInitLoadingAction, EnableNewNpsAction, SetIsNpsLogicVerifiedAction, ToggleShowContextPanel, RequestIdReceivedAction, SetIsDisabledBilling, SetStorefrontNameAction, I18nextReceivedAction, SetInitializedPCAInstanceAction, IncludeTestProductsReceivedAction, IsConverged, SetSearchInHeroAction, AppsPricingDataResetAction, PrivateAppsPricingDataReceivedAction } from '@shared/actions/actions';
import { SetQueryAction, SetRequestFilteredEntityTypeAction, SetRequestFilteredLoadedAction, SetRequestFilteredLoadingAction, SetRequestFilteredQueryAction, SetResponseFilteredQueryAction } from './../actions/queryActions';
import { pick } from 'lodash-es';
import { initialConfigState, copyState } from './../../State';
export default function configReducer(state = initialConfigState, action) {
    const newState = copyState(state);
    if (isType(action, NationalCloudSettingAction)) {
        newState.nationalCloud = action.payload.nationalCloud;
    } else if (isType(action, EmbeddedAppSettingAction)) {
        newState.isEmbedded = action.payload.isEmbedded;
    } else if (isType(action, SetInitLoadingAction)) {
        newState.initLoading = action.payload.initLoading;
    } else if (isType(action, LocStringsReceivedAction)) {
        newState.locStrings = action.payload.localizedstrings;
        newState.locale = action.payload.locale;
    } else if (isType(action, I18nextReceivedAction)) {
        newState.i18nInstance = action.payload.i18nInstance;
    } else if (isType(action, EmbeddedHostAction)) {
        newState.embedHost = action.payload.embedHost;
    } else if (isType(action, FlightCodesReceivedAction)) {
        newState.flightCodes = action.payload.flightCodes;
    } else if (isType(action, IncludeTestProductsReceivedAction)) {
        newState.includeTestProducts = action.payload.includeTestProducts;
    } else if (isType(action, IsConverged)) {
        newState.isConverged = action.payload.isConverged;
    } else if (isType(action, CorrelationIdReceivedAction)) {
        newState.correlationId = action.payload.correlationId;
    } else if (isType(action, RequestIdReceivedAction)) {
        newState.requestId = action.payload.requestId;
    } else if (isType(action, BreadcrumbAction)) {
        newState.breadcrumbUrl = action.payload.breadcrumbUrl;
    } else if (isType(action, TelemetryLoggedAction)) {
        newState.appViewTelemetryLoggedCount = state.appViewTelemetryLoggedCount + 1;
    } else if (isType(action, SetCurrentViewAction)) {
        // currentView is one of routes property `name` in routerHistory.tsx
        newState.currentView = action.payload.currentView;
    } else if (isType(action, SetLandingViewAction)) {
        // landingView is one of routes property `name` in routerHistory.tsx
        newState.landingView = action.payload.landingView;
    } else if (isType(action, UpdateCurrentGalleryViewIsCuratedAction)) {
        // determine whether current render gallery view is curated
        newState.currentGalleryViewIsCurated = action.payload.isCuratedGalleryView;
    } else if (isType(action, AppsPricingDataReceivedAction)) {
        newState.startingPricingData = _object_spread({}, state.startingPricingData, action.payload.pricingData);
        newState.billingCountryCode = action.payload.countryCode.toLowerCase();
    } else if (isType(action, PrivateAppsPricingDataReceivedAction)) {
        newState.privateStartingPricingData = _object_spread({}, state.privateStartingPricingData, action.payload.pricingData);
        newState.billingCountryCode = action.payload.countryCode.toLowerCase();
        newState.privatePricingDataLoaded = true;
    } else if (isType(action, AppsPricingDataResetAction)) {
        newState.startingPricingData = null;
        newState.privateStartingPricingData = null;
    } else if (isType(action, FeatureFlagsReceivedAction)) {
        const keys = Object.keys(action.payload);
        const keysLength = keys.length;
        for(let i = 0; i < keysLength; i++){
            newState.featureFlags[keys[`${i}`]] = action.payload[keys[`${i}`]];
        }
    } else if (isType(action, SetQueryAction)) {
        newState.query = action.payload.query;
    } else if (isType(action, SetRequestFilteredLoadingAction)) {
        newState.requestFilteredLoading = true;
    } else if (isType(action, SetRequestFilteredLoadedAction)) {
        newState.requestFilteredLoading = false;
    } else if (isType(action, SetRequestFilteredQueryAction)) {
        newState.requestFilteredQuery = action.payload.requestFilteredQuery;
    } else if (isType(action, SetRequestFilteredEntityTypeAction)) {
        newState.requestFilteredEntityType = action.payload.requestFilteredEntityType;
    } else if (isType(action, SetResponseFilteredQueryAction)) {
        newState.responseFilteredQuery = action.payload.responseFilteredQuery;
    } else if (isType(action, BillingRegionAction)) {
        newState.billingCountryCode = action.payload.billingRegion;
    } else if (isType(action, ABTestingEnableAction)) {
        newState.experiment.abTestingVersion_AMP = action.payload.abTestingVersion_AMP;
        newState.experiment.abTestingVersion_newFilterAMP = action.payload.abTestingVersion_newFilterAMP;
    } else if (isType(action, GlobalSettingsReceivedAction)) {
        Object.assign(newState, _object_spread({}, pick(action.payload.globalSettings, [
            'marketplaceApiHost',
            'saasRPHost',
            'marketplaceLeadsHost',
            'marketplaceLeadsAudienceId',
            'armApiHost',
            'MPRPHost',
            'partnersIframeUrl',
            'partnersIframeUrlTest',
            'telemetryInstrumentationKey',
            'loggingInstrumentationKey',
            'partnersApiHost',
            'appVersion',
            'region',
            'requestId',
            'correlationId',
            'reviewsAPI',
            'linkedinAPI',
            'linkedinAPIVersion',
            'communityAPI',
            'communityAPIVersion',
            'siteEnvironment',
            'agorasEnvironment',
            'aadApplicationId',
            'aadLoginUrl',
            'commerceApiHost',
            'oneCatalogApiHost',
            'telemetryEndpoint',
            'msClarityId',
            'searchApiEndpoint',
            'expHeaderDisabled',
            'enableOneTaxonomy',
            'jarvisCM',
            'mprpAadApplicationId',
            'pifdEndpoint',
            'commerceApi',
            'graphApi',
            'agreementAppId',
            'isConverged',
            'enableUrlChanges',
            'allowedDomains'
        ])));
    } else if (isType(action, IsMobileReceivedAction)) {
        newState.isMobile = action.payload.isMobile;
    } else if (isType(action, CheckoutConfigAction)) {
        newState.pidlEnv = action.payload.checkoutSettings.pidlEnv;
    } else if (isType(action, IsManageModalOpenAction)) {
        newState.cookiesConsent.isManageModalOpen = action.payload;
    } else if (isType(action, SetWCPConsentAction)) {
        newState.cookiesConsent.WCPConsent = action.payload;
    } else if (isType(action, SetIsConsentRequired)) {
        newState.cookiesConsent.isConsentRequired = action.payload;
    } else if (isType(action, SetSearchInHeroAction)) {
        newState.isSearchInHero = action.payload;
    } else if (isType(action, EnableNewNpsAction)) {
        newState.newNpsEnabled = action.payload.enable;
    } else if (isType(action, SetInitializedPCAInstanceAction)) {
        newState.pcaInstanceInitialized = action.payload.initialized;
    } else if (isType(action, SetIsNpsLogicVerifiedAction)) {
        newState.npsLogicVerified = action.payload.verified;
    } else if (isType(action, ToggleShowContextPanel)) {
        newState.showContextPanel = !state.showContextPanel;
    } else if (isType(action, ChangeLocaleLanguage)) {
        newState.locale = action.payload.locale;
    } else if (isType(action, SetIsDisabledBilling)) {
        newState.isDisabledBilling = action.payload;
    } else if (isType(action, SetStorefrontNameAction)) {
        newState.storefrontName = action.payload;
    } else {
        return state;
    }
    return newState;
}
